import Route from '@ember/routing/route';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { TrackedArray } from 'tracked-built-ins';

export default Route.extend({
  contactsCache: service(),

  model() {
    let groupModel = this.modelFor('funds.fund.groups.group');
    let groupContacts = get(
      this,
      `contactsCache.groupContacts.${groupModel.group}.contacts`,
    );
    if (groupContacts == null) {
      groupContacts = [];
    }
    let contactIdsInGroup = {};
    groupContacts.forEach((contact) => {
      contactIdsInGroup[get(contact, 'id')] = true;
    });
    let contactsNotInGroup = new TrackedArray(get(this, 'contactsCache.contacts').filter(
      (contact) => {
        return contactIdsInGroup[get(contact, 'id')] !== true;
      },
    ));

    return Object.assign({}, groupModel, {
      contactsNotInGroup,
    });
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
